//import VueRouter from "vue-router";
//const API_URL='http://www.silimbani.com/MyTodoApi/api/mytodo'
//const API_URL= 'http://localhost:20000/api/mytodo'
//import { authHeader } from '../helpers/authHeaders.js';
const API_URL = process.env.VUE_APP_API_URL+'/nc'

import { router } from '../main.js'


export const userService = {

    login,
    logout,
    getComuInfo,
    getListaAc,
    getAcDetails,
    getNcDetails,
    getSessionId,
    saveSessionId,
    
    updateListTitle,
    getUserInfo,
    getProgress,
    downloadPb,
    getGeoJson,
    getComuniAbilitati,
    getCurrentComune,
    setCurrentComune,
    generateUid,
    getMarkers,
    goBack,
    anaFind,
    anaGet,
    handleResponse,    
    getStoreCurrentComune,

};
function getStoreCurrentComune(){
    return getUserInfo().currentComune;
    
}
function generateUid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (
        c
    ) {
        var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
function login(user, password) {

    const requestOptions = {
        method: 'POST',

        headers: { 'Content-Type': 'application/json', 'Authorization': '1111' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ user, password })
    };


    return fetch(API_URL + '/login', requestOptions)
        .then(handleResponse)
        .then(user => {
            // login successful if there's a jwt token in the response

            if (user.sid) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                
                this.saveSessionId(user.sid, user.userId, user.comuniAbilitati, '')
            }

            return user;
        
        });
}

function logout() {

    var ui = getUserInfo();
    var sid = ui.sid;
    // faccio scadere il coockie
    var d = new Date();
    let cname = "userInfo"
    let exdays = '1200'

    let userInfo = {  }

    d.setTime(d.getTime() - (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + JSON.stringify(userInfo) + ";" + expires + ";SameSite=Lax;path=/";




    localStorage.removeItem('sid');
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': '1111' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid })
    };


    return fetch(API_URL + '/logout', requestOptions).then(handleResponse)
}

function getUserInfo() {
    let tmp = getCookie('userInfo')
    if (tmp) {
        let userInfo = JSON.parse(tmp)
        return userInfo
    } else {
        let sid = null
        let userId = null
        let nickName = null

        return { sid, userId, nickName }
    }
}
function getSessionId() {
    return getUserInfo().sid
}
function saveSessionId(sid, userId, listaComuni, currentComune) {

    var d = new Date();
    let cname = "userInfo"
    let exdays = '1200'

    let userInfo = { sid, userId, listaComuni, currentComune }

    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + JSON.stringify(userInfo) + ";" + expires + ";SameSite=Lax;path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}


function getCurrentComune() {
    var ui = getUserInfo()


    return ui.currentComune
}
function setCurrentComune(comune) {
    var ui = getUserInfo()
    ui.currentComune = comune
    saveSessionId(ui.sid, ui.userId, ui.listaComuni, ui.currentComune)
    return 'ok'
}
function getComuniAbilitati() {
    const sid = this.getSessionId()
    
    
   const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': '1111' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid })
    };
    return fetch(API_URL + '/getComuniAbilitati', requestOptions).then(handleResponse)
        .then(ret => {
            if (ret) {
                return ret;
            }
            return 'errore';
        });
}
function downloadPb(uid,file_name){
   // alert('serv.getProgress: uid='+uid);
    const sid = this.getSessionId()
    const comune = this.getCurrentComune()
    const pbUid=uid;
    const fileName=file_name;

    

    return API_URL + '/downloadPb/'+sid+'/'+comune+'/'+pbUid+'/'+fileName;
    /*return fetch(API_URL + '/downloadPb/'+sid+'/'+comune+'/'+pbUid+'/'+fileName, requestOptions).then(handleResponse)
        .then(ret => {
            

            if (ret) {
                //alert('service:downloadPb:'+uid+" valRet="+JSON.stringify(ret))
                return ret;
            }

            return 'errore';
        });*/
}
function getProgress(uid){
     const sid = this.getSessionId()
     const comune = this.getCurrentComune()
     const pbUid=uid;
    const requestOptions = {
         method: 'POST',
         headers: { 'Content-Type': 'application/json', 'Authorization': '1111' },
         mode: "cors",
         cache: "default",
         body: JSON.stringify({ sid, comune, pbUid })
     };
     return fetch(API_URL + '/getPbStatus', requestOptions).then(handleResponse)
         .then(ret => {
             if (ret) {
                 return ret;
             }
             return 'errore';
         });
 }
 
function getListaAc(filter, maxResultIn) {
    const sid = this.getSessionId()
    const comune = this.getCurrentComune()
const maxResult=''+maxResultIn
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': '1111' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid, comune, filter, maxResult })
    };


    return fetch(API_URL + '/getAcList', requestOptions).then(handleResponse)
        .then(ret => {
            

            if (ret) {

                return ret;
            }

            return 'errore';
        });
}
function getComuInfo() {
    const sid = this.getSessionId()
    const comune = this.getCurrentComune()

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': '1111' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid, comune })
    };


    return fetch(API_URL + '/getComuInfo', requestOptions).then(handleResponse)
        .then(ret => {
            if (ret) {
               // alert(' user service'+JSON.stringify(ret));
                return ret;
            }
            return 'errore';
        });
}
function anaFind(p) {
    const sid = this.getSessionId()
    const comune = this.getCurrentComune()
    const searchPar = p
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': '1111' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid, comune, searchPar })
    };



    return fetch(API_URL + '/findAna', requestOptions).then(handleResponse)
        .then(ret => {
            if (ret) {
                return ret;
            }
            return 'errore';
        }, rejected => {

            return rejected;
        });
}
function anaGet(panaType, prg) {
    const sid = this.getSessionId()
    const comune = this.getCurrentComune()
    const prgAna = prg;
    const anaType = panaType;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': '1111' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid, comune, anaType, prgAna })

    };



    return fetch(API_URL + '/getAna', requestOptions).then(handleResponse)
        .then(ret => {
            // login successful if there's a jwt token in the response
            //alert(JSON.stringify(ret));
            if (ret) {

                return ret;
            }

            return 'errore';
        }, rejected => {

            return rejected;
        });
}

function getAcDetails(prgAc) {
    const sid = this.getSessionId()
    const comune = this.getCurrentComune()
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': '1111' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid, comune, prgAc })
    };


    return fetch(API_URL + '/getAcDetails', requestOptions).then(handleResponse)
        .then(ret => {
            // login successful if there's a jwt token in the response

            if (ret) {

                return ret;
            }

            return 'errore';
        });
}
function getGeoJson(comuneIn,shapeName) {
    
    const sid = this.getSessionId()
    const comune = comuneIn
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': '1111' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid, comune, shapeName })
    };
    //const key = comune + '_' + shapeName;
    /*
    if (hasMap(mapStorage,key)) {
        alert('preso da cache')
        return getMap(mapStorage,key);
    }*/

    return fetch(API_URL + '/getGeoJson', requestOptions).then(handleResponse)
        .then(ret => {
            // login successful if there's a jwt token in the response

            if (ret) {
               // setMap(mapStorage,key, JSON.stringify(ret));
               
                return ret;
            }

            return 'errore';
        });
}
function getNcDetails(prgIndirizzo) {
    const sid = this.getSessionId()
    const comune = this.getCurrentComune()
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': '1111' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid, comune, prgIndirizzo })
    };


    return fetch(API_URL + '/getNcDetails', requestOptions).then(handleResponse)
        .then(ret => {
            // login successful if there's a jwt token in the response

            if (ret) {

                return ret;
            }

            return 'errore';
        });
}
function getMarkers(prgIndirizzo) {
    const sid = this.getSessionId()
    const comune = this.getCurrentComune()

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid, comune, prgIndirizzo })
    };


    return fetch(API_URL + '/getMarkers', requestOptions).then(handleResponse)
        .then(ret => {
            if (ret) {
                return ret;
            }
            return 'errore';
        });
}





function updateListTitle(title) {
    const sid = this.getSessionId()
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sid, title })
    };


    return fetch(API_URL + '/updateListTitle', requestOptions).then(handleResponse)
        .then(ret => {
            // login successful if there's a jwt token in the response

            if (ret.lista) {

                return ret.lista;
            }

            return 'errore';
        });
}




function goBack() {
    router.go(-1);

}

function handleResponse(response) {
    return response.text().then(text => {
        /* eslint-disable no-console */
        // console.log(text)
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                const cr = router.currentRoute

                if (cr.fullPath != '/login') {
                    router.push('/login')
                }


            }

            // const error = (data && data.message) || response.statusText;
            //return Promise.reject(response);

            return response;
        }

        return data;
    });

}